import React, { useEffect, useState } from 'react';
import { observationAvailability } from '../hooks/useObservationActivity';
import ObservationStatus from './ObservationStatus';

export default function OperationalPollingStatus({ query, onRefresh }) {
  const [availability, setAvailability] = useState(observationAvailability);
  useEffect(() => {
    const update = () => setAvailability(observationAvailability());
    document.addEventListener('visibilitychange', update);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);
  return <ObservationStatus reason={availability || (query.isError ? 'failure' : null)} lastReadAt={query.dataUpdatedAt} onResume={onRefresh || (() => query.refetch())} disabled={query.isFetching} />;
}
